<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="800px"
    :before-close="handleClose"
    custom-class="peopleDialog">
    <div class="title" slot="title">
      预收资金数额
    </div>
    <div class="list">
      <div class="flex justify-end">
        <div class="btnUp" @click="innerVisible = true">添加</div>
      </div>
      <el-table
        :data="tableData"
        :header-cell-style="centerbgc"
        :cell-style="textCenter"
        style="width: 100%">
        <el-table-column
          label="预收金额(元)"
          prop="yushou"
          width="250">
        </el-table-column>
        <el-table-column
          label="填写日期"
          prop="date">
        </el-table-column>
        <el-table-column
          label="操作"
          width="250">
          <template slot-scope="scope" class="flex">
            <div class="edit" @click="edit(scope)">编辑</div>
            <div class="del" @click="del(scope)">删除</div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="page-box">
      <el-pagination
        :current-page.sync="search.page"
        :page-size="search.limit"
        :total="search.total"
        background
        class="page-all margin-top self-end"
        layout="prev, pager, next"
        @current-change="list">
      </el-pagination>
    </div>

    <el-dialog
      width="600px"
      :visible.sync="innerVisible"
      :before-close="innerhandleClose"
      append-to-body>
      <div class="title" slot="title">
        {{id ? '编辑' : '添加'}}
      </div>
      <div class="form-content">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="top" class="ruleFormYan">
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="预收资金数额" ref="num" prop="num">
                <div class="flex justify-start align-center">
                  <el-input v-model="ruleForm.num" class="inp">
                    <template  slot="append">元</template>
                  </el-input>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item class="errorTips" label="上传变更证明" ref="file" prop="file">
                <div class="flex justify-start align-center">
                  <a :href="ruleForm.file" target="_blank" download rel="noopener" v-if="ruleForm.file"
                     class="look">查看变更证明</a>
                  <upload-file
                    class="upZuj margin-0"
                    name="file"
                    @uploadFile="uploadFile"
                  >
                    <div class="btnUp" slot="upload">
                      <i class="iconfont icon-iconfontzhizuobiaozhun0263"></i> 上传变更证明
                    </div>
                  </upload-file>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="btn-box">
          <div class="btn" @click="submitForm('ruleForm')">确定</div>
        </div>
      </div>

    </el-dialog>


  </el-dialog>
</template>
<script>
import {
  del_yushou,
  save_yushou,
  yushou
} from '@/api/index'
import UploadFile from "@/components/UploadFile";
export default {
  name: "supervisionDialog",
  data() {
    return {
      innerVisible:false,
      id:'',
      tableData:[],
      search:{
        page:1,
        limit:5,
        total:0,
      },
      ruleForm: {
        num: '', // 是否开立资金存管账户
        file: '', // 变更证明
      },
      rules: {
        num: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
        file: [
          {required: false, message: '请上传', trigger: 'change'}
        ],
      }
    }
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    noticeid: {
      type: [String, Number],
      default: ''
    }
  },
  computed: {
    textCenter(){
      return {
        textAlign: 'center'
      }
    },
    centerbgc(){
      return {
        textAlign: 'center',
        background: '#f7f7f7'
      }
    }
  },
  components: {UploadFile},
  created() {
    this.list()
  },
  methods: {

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitInfo()
        }
      });
    },
    async submitInfo() {
      let _data = await save_yushou(
        this.id,
        this.ruleForm.num,
        this.ruleForm.file,
      );
      if(_data.status == 200){
        this.$message.success(_data.msg)
        this.innerVisible = false
        this.ruleForm.num = ''
        this.ruleForm.file = ''
        this.id = ''
        this.list()
        if(this.noticeid) {
          this.$emit('handleClose',true)
        }
      }else{
        this.$message.error(_data.msg)
      }
    },
    async list(){
      let _data = await yushou(
        this.search.page,
        this.search.limit
      );
      if(_data.status == 200){
        this.tableData = _data.data.data
        this.search.total = _data.data.total
      }
    },
    del(scope){
      this.$confirm('是否删除该数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.delInfo(scope.row.id)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    async delInfo(id){
      let _data = await del_yushou(id);
      if(_data.status == 200){
        this.$message.success(_data.msg)
        this.list()
      }else{
        this.$message.error(_data.msg)
      }
    },
    async edit(scope){
      this.id = scope.row.id
      this.ruleForm.num = scope.row.yushou
      this.ruleForm.file = scope.row.file
      this.innerVisible = true
    },
    innerhandleClose(){
      this.ruleForm.num = ''
      this.ruleForm.file = ''
      this.id = ''
      this.innerVisible = false
      this.$refs.ruleForm.resetFields()
    },
    handleClose(){
      this.$emit('handleClose',false)
    },
    uploadFile(data) {
      this.ruleForm[data.name] = data.file.url
    },
  },
  watch: {
    dialogVisible(){
      if(this.dialogVisible) {
        console.log(this.id)
      }
    }
  },
  filters: {}
}
</script>

<style scoped lang="scss">
/deep/ {
  .peopleDialog .el-dialog__body {
    padding-top: 0;
  }
}
.btnUp {
  width: 120px;
  height: 36px;
  margin-left: 10px;
  background-image: linear-gradient(90deg,
    #2791ff 0%,
    #81b6ff 100%);
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  color: #ffffff;
  margin-bottom: 10px;
  cursor: pointer;

  i {
    font-size: 20px;
    color: #ffffff;
    margin-right: 5px;
    font-weight: 100;
  }
}
.edit {
  font-size: 14px;
  color: #0089ff;
  padding: 4px 10px;
  display: inline-block;
  cursor: pointer;
}
.del {
  font-size: 14px;
  color: #ff0000;
  padding: 4px 10px;
  display: inline-block;
  cursor: pointer;
}
.title {
  font-size: 18px;
  font-weight: bold;
  color: #333333;
}
.form-content {
  width: 100%;

  .title-flex {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-bottom: 20px;

    b {
      font-size: 18px;
      color: #000000;
      font-weight: bold;
      margin-right: 10px;
    }
  }


  .width {
    width: 400px;
  }

  .btn-box {
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 20px 0;

    .btn {
      width: 180px;
      height: 40px;
      background-image: linear-gradient(0deg,
        #2791ff 0%,
        #81b6ff 100%);
      border-radius: 20px;
      text-align: center;
      line-height: 40px;
      font-size: 16px;
      letter-spacing: 1px;
      color: #ffffff;
    }
  }

  .add {
    width: 24px;
    cursor: pointer;
  }


  .inp {
    flex: 1;
  }

  .tips {
    width: max-content;
    padding: 0 10px;
    height: 36px;
    background-color: #fef0ef;
    border-radius: 4px;
    margin-left: 10px;
    font-size: 14px;
    color: #f34336;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    line-height: 16px;

    i {
      font-size: 20px;
      color: #f34336;
      margin-right: 4px;
    }

    &.width {
      width: 160px;
    }
  }

  .look {
    width: max-content;
    padding: 0 10px;
    height: 36px;
    border: 1px solid #2791ff;
    color: #2791ff;
    line-height: 34px;
    text-align: center;
    font-size: 14px;
    margin-left: 10px;
    border-radius: 4px;
  }


}

.title-box {
  width: 100%;
  height: 60px;
  border-bottom: solid 2px #e3e7f0;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .tit-left {
    display: flex;
    justify-content: flex-start;
    padding-top: 25px;
    padding-bottom: 15px;

    .icon-box {
      width: 30px;
      height: 30px;
      background-image: linear-gradient(-30deg,
        #3579fb 0%,
        #44a3ff 100%);
      box-shadow: 0px 10px 10px 0px
      rgba(50, 150, 255, 0.3);
      border-radius: 10px;
      text-align: center;
      line-height: 30px;
      i {
        font-size: 17px;
        color: #ffffff;
      }
    }

    b {
      font-size: 22px;
      color: #16181d;
      font-weight: bold;
      margin-left: 5px;
    }
  }
}
</style>


